import React from "react";
import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import Notification from "views/Notifications/Notifications.jsx";
import ReportsLanding from "layouts/recordsLanding/recordsLanding.jsx";
import Landing from "layouts/Landing/landing.jsx";
import Login from "layouts/Login/Login.jsx";
import NotFound from "layouts/NotFound/Index.jsx";
import { Route, Switch } from "react-router-dom";
import CookiesPolicy from "../views/policies/cookies-policy";
import PrivacyPolicy from "../views/policies/privacy-policy";
import CustomerAwarenessPolicy from "../views/policies/customer-awarness-policy";
// const indexRoutes = [
//   { path: "/login", component: Login },
//   { path: "/", component: Dashboard }
// ];

const indexRoutes = (
  <Switch>
    <Route exact component={Login} path="/login" />
    <Route exact component={CookiesPolicy} path="/cookie-policy" />
    <Route exact component={PrivacyPolicy} path="/privacy-policy" />
    <Route exact component={CustomerAwarenessPolicy} path="/customer-awareness-policy" />
    <Route exact component={Landing} path="/" />
    <Route exact component={Landing} path="/landing" />
    <Route exact component={Notification} path="/notification" />
    <Route exact component={ReportsLanding} path="/reports-landing" />
    <Route component={Dashboard} path="/app" />
    <Route component={NotFound} path="**" />
  </Switch>
);

export default indexRoutes;


// WEBPACK FOOTER //
// ./src/routes/index.jsx